export const SUGGESTED_TASKS: string[] = [
  'Obtain ID document',
  'Obtain Death Certificate',
  'Obtain Birth Certificate of minor/s',
  'Obtain Marriage Certificate',
  'Obtain Police Report',
  'Obtain Hospital Records',
  'Obtain Hospital/medical accounts',
  "Obtain Employer's Certificate",
  'Obtain Inquest record',
  'Obtain Photos of accident scene',
  "Obtain Photos of client/minor's scarring",
  'Obtain Funeral accounts',
  "Obtain Witnesses' statements from SAPS",
  'Obtain Workmen Comp docs',
  "Obtain Driver's license",
  'Obtain Special Power of Attorney',
  'Complete RAF1 form',
  'Complete RAF1 medical report',
  'Complete RAF4 serious injury assessment',
  'Complete Contingency Fee Agreement',
  'Prepare Affidavit from client',
  'Prepare Affidavit/s from witnesses',
  'Prepare Sketch plan',
  'Prepare Authorisation',
  'Appoint Orthopaedic Surgeon',
  'Appoint Occupational Therapist',
  'Appoint Industrial Psychologist',
  'Appoint Actuary',
  'Obtain undertaking to reimburse medical aid',
  'Obtain confirmation from SAPS re criminal investigation',
  'Obtain SASSA confirmation',
  'Obtain Public Carrier permit',
  'Follow up with client',
  'Follow up with RAF',
  'Follow up with expert',
  'Send demand letter',
  'File pleadings',
  'Prepare trial bundle',
];
